export const QUOTE_CONTEXT_NAME_MAPPING = [
  { quoteKey: "CoverageA", contextKey: "CoverageA" },
  { quoteKey: "CoverageB", contextKey: "CoverageB" },
  { quoteKey: "OptionCoverageB", contextKey: "OptionCoverageB" },
  { quoteKey: "CoverageC", contextKey: "CoverageC" },
  { quoteKey: "OptionCoverageC", contextKey: "OptionCoverageC" },
  { quoteKey: "CoverageD", contextKey: "CoverageD" },
  { quoteKey: "OptionCoverageD", contextKey: "OptionCoverageD" },
  { quoteKey: "CoverageE", contextKey: "CoverageE" },
  { quoteKey: "CoverageF", contextKey: "CoverageF" },
  { quoteKey: "CoverageL", contextKey: "CoverageL" },
  { quoteKey: "CoverageM", contextKey: "CoverageM" },
  {
    quoteKey: "AllOtherPerilsDeductible",
    contextKey: "AllOtherPerilsDeductible"
  },
  { quoteKey: "HurricaneDeductible", contextKey: "HurricaneDeductible" },
  { quoteKey: "WindHailDeductible", contextKey: "WindHailDeductible" },
  { quoteKey: "WaterBackupCoverage", contextKey: "WaterBackupCoverage" },
  {
    quoteKey: "IdentityFraudCoverage",
    contextKey: "IdentityFraudCoverage"
  },
  {
    quoteKey: "MechanicalBreakdownCoverage",
    contextKey: "MechanicalBreakdownCoverage"
  },
  { quoteKey: "ServiceLineCoverage", contextKey: "ServiceLineCoverage" },
  { quoteKey: "StructureType", contextKey: "StructureType" },
  { quoteKey: "PropertyOccupancy", contextKey: "PropertyOccupancy" },
  { quoteKey: "ConstructionYear", contextKey: "ConstructionYear" },
  {
    quoteKey: "ConstructionYearRoof",
    contextKey: "ConstructionYearRoof"
  },
  { quoteKey: "RoofCoveringType", contextKey: "RoofCoveringType" },
  {
    quoteKey: "ReplacementCostBuilding",
    contextKey: "ReplacementCostBuilding"
  },
  {
    quoteKey: "DistanceToCoast",
    contextKey: "DistanceToCoast"
  }
];

export const QUOTE_SOURCES = {
  AP: "Agent Portal",
  EXTERNAL: "External",
  CR: "Comparative Rater",
  REMARKETED: "SageSure Remarketed Quote",
  ONLINE_LEAD: "SageSure Online Lead",
  OTHER: "Other"
};

export const QUOTE_SOURCE_MAPPING = {
  "Agent Portal": QUOTE_SOURCES.AP,
  "Agent Portal - FastPremium": QUOTE_SOURCES.AP,
  pxClient: QUOTE_SOURCES.AP,
  "HISS Internal": QUOTE_SOURCES.EXTERNAL,
  "HISS External": QUOTE_SOURCES.EXTERNAL,
  HISS: QUOTE_SOURCES.EXTERNAL,
  "not-matic": QUOTE_SOURCES.EXTERNAL,
  QuoteRush: QUOTE_SOURCES.EXTERNAL,
  SEMCAT: QUOTE_SOURCES.EXTERNAL,
  "HTML Forms": QUOTE_SOURCES.EXTERNAL,
  Progressive: QUOTE_SOURCES.EXTERNAL,
  "Liberty Mutual": QUOTE_SOURCES.EXTERNAL,
  "Prosper - Book Roll": QUOTE_SOURCES.EXTERNAL,
  Dovetail: QUOTE_SOURCES.EXTERNAL,
  "Runscope Monitoring": QUOTE_SOURCES.EXTERNAL,
  GIQ: QUOTE_SOURCES.EXTERNAL,
  ezlynx: QUOTE_SOURCES.CR,
  Ivantage: QUOTE_SOURCES.CR,
  "Sagesure.com Online Lead": QUOTE_SOURCES.ONLINE_LEAD
};

export const TRACKING_LABELS = {
  view: "Quote Home - View",
  action: "Quote Home - Action",
  shareButton: "Quote Home - Share Button Clicked",
  checkoutButton: "Quote Home - Checkout Button Clicked",
  effectiveDate: "Quote Home - Effective Date Changed",
  compareProducts: "Quote Home - Compare Products Clicked",
  copyButton: "Share Quote Modal - Copy Button Clicked",
  openButton: "Share Quote Modal - Open Button Clicked"
};

export const QUOTE_DATA_SECTIONS = {
  coreCoverages: [
    "ReplacementCostBuilding",
    "CoverageA",
    "OptionCoverageB",
    "CoverageB",
    "OptionCoverageC",
    "CoverageC",
    "OptionCoverageD",
    "CoverageD",
    "CoverageE",
    "CoverageF",
    "CoverageL",
    "CoverageM"
  ],
  deductibles: [
    "AllOtherPerilsDeductible",
    "HurricaneDeductible",
    "WindHailDeductible"
  ],
  optionalCoverages: [
    "WaterBackupCoverage",
    "IdentityFraudCoverage",
    "MechanicalBreakdownCoverage",
    "ServiceLineCoverage"
  ],
  property: [
    "StructureType",
    "PropertyOccupancy",
    "ConstructionYear",
    "ConstructionYearRoof",
    "RoofCoveringType"
  ]
};
